import apiService from "service/api";

export const getClinicalNotes = async (hfId: number) => {
  const url = `/vaccine/${hfId}/clinical-notes/`;

  return apiService(url, "GET", null, true);
};

export const createClinicalNotes = async (
  hfId: number,
  formData: Record<string, any>
) => {
  const url = `/vaccine/${hfId}/clinical-notes/`;

  return apiService(url, "POST", formData, true);
};

export const getOneClinicalNote = async (hfId: number, noteId: number) => {
  const url = `/vaccine/${hfId}/clinical-notes/${noteId}/`;

  return apiService(url, "GET", null, true);
};
